export default {
  "phoneInvalid": "Please enter a valid 10-digit phone number",
  "emailRequired": "Email address is required",
  "emailInvalid": "Please enter a valid email address",
  "emailMultipleAt": "Email address should contain exactly one @ symbol",
  "emailInvalidDomain": "Email address has an invalid domain extension",
  "emailDisposable": "Please use a non-disposable email address",
  "emailConsecutiveSpecialChars": "Email address contains consecutive special characters",
  "emailInvalidPositionSpecialChars": "Email address contains special characters at invalid positions",
  "emailIpDomain": "Email address cannot use an IP address as domain",
  "cityContainsNumbers": "City name cannot contain numbers",
  "cityInvalidChars": "City name can only contain letters, spaces",
  "streetInvalidChars": "Street address can only contain letters, numbers, spaces, commas, and #",
  "birthDateTooYoung": "You must be at least 18 years old",
  "birthDateInvalid": "Please enter a valid birth date",
  "zipInvalid": "Please enter a valid 5-digit ZIP code"
} as const;
